<template>
  <div style="height:100%; background-color: #fff;">
    <TwHeader>
      <template #left>
        <tw-breadcrumbs :pages="breadcrumbs" class="mb-2" />
      </template>
    </TwHeader>
    <div class="container mt-4">
      <div style="width:100%;" class="self-start">
        <TwAddTrading />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';

import TwAddTrading from './components/newTrading.vue';

// components
import TwBreadcrumbs from '@/components/molecules/TwBreadcrumbs';

// vue3 components
import TwHeader from '@/components/vue3/TwHeader.vue';

export default defineComponent({
  name: 'NewTradingV3',
  components: {
    TwAddTrading,
    TwHeader,
    TwBreadcrumbs,
  },
  props: {
    onToggleCollapse: {
      type: Function,
      default: () => {},
    },
  },
  setup(_, { root }) {
    const breadcrumbs = computed(() => [
      { label: root.$t('BreadCrumbs.Dashboard'), to: '/' },
      { label: root.$t('BreadCrumbs.New Trading') },
    ]);

    return {
      breadcrumbs,
    };
  },
});
</script>

<style scoped>
/* ---

 TwHeader

--- */
.container {
  padding: 5px 15px 15px;
}
</style>
